export default __webpack_public_path__ + "static/media/snippets.6b0840eb.svg";